module.exports = __webpack_public_path__ + "img/4.e14e5876.jpg";